/* ============================================================
   V-Commerce Pro Theme - JavaScript
   Clean, consolidated. No hardcoded store references.
   ============================================================ */

/* --- Utility: Format price --- */
function formatMoney(cents) {
  var amount = parseFloat(cents) / 100;
  return '$' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

document.addEventListener('DOMContentLoaded', function () {

  /* --- Mobile Menu Toggle --- */
  var menuToggle = document.querySelector('.mobile-menu-toggle');
  var mainNav = document.querySelector('.main-nav');
  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', function () {
      mainNav.classList.toggle('is-open');
      var expanded = mainNav.classList.contains('is-open');
      this.setAttribute('aria-expanded', expanded);
      // Swap hamburger / close icon
      var openIcon = this.querySelector('.icon-menu');
      var closeIcon = this.querySelector('.icon-close');
      if (openIcon) openIcon.style.display = expanded ? 'none' : 'block';
      if (closeIcon) closeIcon.style.display = expanded ? 'block' : 'none';
    });
  }

  /* --- Mobile Nav: Submenu Toggles --- */
  document.querySelectorAll('.nav-item').forEach(function (item) {
    var link = item.querySelector('.nav-link');
    var submenu = item.querySelector('.mega-menu, .dropdown-menu');
    if (link && submenu && window.innerWidth <= 768) {
      link.addEventListener('click', function (e) {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          item.classList.toggle('mobile-open');
        }
      });
    }
  });

  /* --- Mobile Search Drawer --- */
  var searchToggle = document.querySelector('.mobile-search-toggle');
  var searchDrawer = document.querySelector('.mobile-search-drawer');
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function () {
      searchDrawer.classList.toggle('is-open');
      var input = searchDrawer.querySelector('input');
      if (input && searchDrawer.classList.contains('is-open')) input.focus();
    });
  }

  /* --- Product Tabs (Desktop) --- */
  var tabBtns = document.querySelectorAll('.product-tab-btn');
  var tabContents = document.querySelectorAll('.product-tab-content');
  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = this.dataset.tab;
      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      tabContents.forEach(function (c) { c.classList.remove('active'); });
      this.classList.add('active');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  /* --- Product Accordion (Mobile) --- */
  document.querySelectorAll('.accordion-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(this.getAttribute('data-accordion'));
      var isOpen = panel && panel.classList.contains('open');
      // Close all
      document.querySelectorAll('.accordion-panel').forEach(function (p) { p.classList.remove('open'); });
      document.querySelectorAll('.accordion-trigger').forEach(function (b) { b.classList.remove('active'); });
      // Toggle clicked
      if (!isOpen && panel) {
        panel.classList.add('open');
        this.classList.add('active');
      }
    });
  });

  /* --- Product Image Gallery --- */
  var thumbnails = document.querySelectorAll('.product-thumbnail');
  var mainImage = document.querySelector('.product-main-image img');
  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbnails.forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      if (mainImage) {
        mainImage.src = this.dataset.fullSrc || this.querySelector('img').src;
        mainImage.alt = this.querySelector('img').alt;
      }
    });
  });

  /* --- Variant Selector --- */
  var variantSelect = document.querySelector('.product-variant-select');
  var mpnEl = document.querySelector('#mpn-value');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var selected = this.options[this.selectedIndex];
      var price = selected.dataset.price;
      var comparePrice = selected.dataset.comparePrice;
      var available = selected.dataset.available === 'true';
      var sku = selected.dataset.sku;
      var priceEl = document.querySelector('.product-price');
      var addBtn = document.querySelector('.add-to-cart-btn');

      // Update MPN
      if (mpnEl && sku) mpnEl.textContent = sku;

      // Update price
      if (priceEl && price) {
        priceEl.innerHTML = formatMoney(price);
        if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
          priceEl.innerHTML += ' <span class="compare-price">' + formatMoney(comparePrice) + '</span>';
        }
      }

      // Update button state
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    });
  }

  /* --- Quantity Buttons --- */
  document.querySelectorAll('.cart-qty button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentElement.querySelector('input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (this.classList.contains('qty-minus')) {
        val = Math.max(1, val - 1);
      } else {
        val += 1;
      }
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* --- Auto-Link Phone Numbers & Emails in Product Descriptions --- */
  (function () {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var phoneRegex = /\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/g;
    var emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
    var nodes = [];
    while (walker.nextNode()) {
      var node = walker.currentNode;
      if (node.parentElement && !['A', 'SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT'].includes(node.parentElement.tagName)) {
        if (phoneRegex.test(node.textContent) || emailRegex.test(node.textContent)) {
          nodes.push(node);
        }
        phoneRegex.lastIndex = 0;
        emailRegex.lastIndex = 0;
      }
    }
    nodes.forEach(function (node) {
      var html = node.textContent;
      html = html.replace(phoneRegex, function (match) {
        var digits = match.replace(/\D/g, '');
        return '<a href="tel:+1' + digits + '">' + match + '</a>';
      });
      html = html.replace(emailRegex, function (match) {
        return '<a href="mailto:' + match + '">' + match + '</a>';
      });
      if (html !== node.textContent) {
        var span = document.createElement('span');
        span.innerHTML = html;
        node.parentElement.replaceChild(span, node);
      }
    });
  })();

  /* --- Wrap Product Description Tables for Mobile Scroll --- */
  document.querySelectorAll('.product-description-styled table').forEach(function (table) {
    if (!table.parentElement.classList.contains('table-scroll-wrapper')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'table-scroll-wrapper';
      table.parentElement.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  });

  /* --- Recently Viewed Products: Track --- */
  (function () {
    var STORAGE_KEY = 'vcommerce_recently_viewed';
    if (window.location.pathname.indexOf('/products/') !== -1) {
      var handle = window.location.pathname.split('/products/')[1];
      if (handle) {
        handle = handle.split('?')[0].split('#')[0];
        var viewed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        viewed = viewed.filter(function (h) { return h !== handle; });
        viewed.unshift(handle);
        if (viewed.length > 12) viewed = viewed.slice(0, 12);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
      }
    }
  })();

  /* --- Recently Viewed Products: Render --- */
  (function () {
    var STORAGE_KEY = 'vcommerce_recently_viewed';
    var container = document.querySelector('.recently-viewed-products');
    if (!container) return;
    var viewed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    var currentHandle = window.location.pathname.split('/products/')[1];
    if (currentHandle) currentHandle = currentHandle.split('?')[0].split('#')[0];
    viewed = viewed.filter(function (h) { return h !== currentHandle; });
    if (viewed.length === 0) {
      var section = container.closest('section');
      if (section) section.style.display = 'none';
      return;
    }
    var toShow = viewed.slice(0, 4);
    var fetched = 0;
    var html = '';
    toShow.forEach(function (handle) {
      fetch('/products/' + handle + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var p = data.product;
          var img = p.image ? p.image.src : '';
          var price = formatMoney(p.variants[0].price * 100);
          html += '<div class="product-card">';
          html += '<a href="/products/' + p.handle + '" class="product-card-image">';
          if (img) html += '<img src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">';
          html += '</a>';
          html += '<div class="product-card-body">';
          html += '<p class="product-card-vendor">' + (p.vendor || '') + '</p>';
          html += '<h3 class="product-card-title"><a href="/products/' + p.handle + '">' + p.title + '</a></h3>';
          html += '<p class="product-card-price">' + price + '</p>';
          html += '</div></div>';
          fetched++;
          if (fetched === toShow.length) container.innerHTML = html;
        })
        .catch(function () { fetched++; });
    });
  })();

  /* --- Related Products Slider Navigation --- */
  document.querySelectorAll('.slider-nav').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var track = this.closest('.related-products-slider').querySelector('.related-products-track');
      if (!track) return;
      var card = track.querySelector('.product-card');
      var scrollAmount = card ? card.offsetWidth + 20 : 300;
      if (this.classList.contains('slider-nav--prev')) {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    });
  });

  /* --- Collection Sort --- */
  var sortSelect = document.querySelector('.collection-sort select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* --- Footer Accordion (Mobile) --- */
  document.querySelectorAll('.footer-col .footer-heading').forEach(function (heading) {
    heading.addEventListener('click', function () {
      if (window.innerWidth > 768) return;
      var col = this.closest('.footer-col');
      var panel = col.querySelector('[data-footer-panel]');
      if (!panel) return;
      var isOpen = col.classList.contains('footer-open');
      // Close all
      document.querySelectorAll('.footer-col').forEach(function (c) {
        c.classList.remove('footer-open');
        var p = c.querySelector('[data-footer-panel]');
        if (p) p.style.maxHeight = '0';
      });
      // Toggle
      if (!isOpen) {
        col.classList.add('footer-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

});
